import { render, staticRenderFns } from "./PhoneThree.vue?vue&type=template&id=0bb15d56&scoped=true&"
import script from "./PhoneThree.vue?vue&type=script&lang=js&"
export * from "./PhoneThree.vue?vue&type=script&lang=js&"
import style0 from "./PhoneThree.vue?vue&type=style&index=0&id=0bb15d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb15d56",
  null
  
)

export default component.exports